import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Form, Input, Modal, message, Button, Row, Col,
} from 'antd';
import {
  editRemittance,
  getBanks,
} from './ducks';
import Select from '../../components/Select';

function RemittanceUpdateModal({
  editModalVisibility,
  setEditModalVisibility,
  rowDetails,
  setRowDetails,
  onTableUpdate,
  doGetBanks,
  ...props
}) {
  const {
    form,
    doUpdateRemittanceRequest,
  } = props;

  const { getFieldDecorator, setFieldsValue } = form;

  const [isUpdating, setIsUpdating] = useState(false);
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    if (rowDetails) {
      setFieldsValue({
        bank_ref: rowDetails.bank_ref || '',
        bank_name: rowDetails.bank_name || '',
      });
    }
  }, [editModalVisibility, rowDetails, setFieldsValue]);

  // Get banks when modal is opened
  useEffect(() => {
    if (editModalVisibility) {
      doGetBanks()
        .then((res) => {
          if (res.payload.data.code === 200) {
            setBanks(res.payload.data.data);
          }
        })
        .catch(() => {
          message.error('Failed to load banks.');
        });
    }
  }, [editModalVisibility, doGetBanks]);

  function UpdateData() {
    const { validateFields } = form;

    setIsUpdating(true);

    validateFields((err, values) => {
      if (!err) {
        const data = {
          ...values,

          // Original values so backend knows which records to update
          current_bank_ref: rowDetails.bank_ref,
          current_bank_name: rowDetails.bank_name,
        };

        doUpdateRemittanceRequest(data)
          .then((res) => {
            message.success(res.payload.data.message);

            setIsUpdating(false);
            setEditModalVisibility(false);

            if (setRowDetails) {
              setRowDetails({
                bank_ref: '',
                bank_name: '',
              });
            }

            if (onTableUpdate) {
              onTableUpdate();
            }
          })
          .catch((resErr) => {
            if (
              resErr.error
              && resErr.error.response
              && resErr.error.response.status === 422
            ) {
              message.error(
                resErr.error.response.data.message,
                3,
              );
            } else {
              message.error('Failed to update remittance.');
            }

            setIsUpdating(false);
          });
      } else {
        setIsUpdating(false);
      }
    });
  }

  return (
    <Modal
      title="Edit Bank Information"
      closable={false}
      visible={editModalVisibility}
      onCancel={() => setEditModalVisibility(false)}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setEditModalVisibility(false);
          }}
          disabled={isUpdating}
        >
          Cancel
        </Button>,

        <Button
          key="update"
          type="primary"
          loading={isUpdating}
          onClick={UpdateData}
        >
          Update
        </Button>,
      ]}
    >
      <Form>
        <Row gutter={12}>
          <Col xs={24} sm={12}>
            <Form.Item label="Bank Reference">
              {getFieldDecorator('bank_ref', {
                rules: [
                  {
                    required: true,
                    message: 'Bank reference is required',
                  },
                ],
              })(
                <Input
                  autoComplete="off"
                  placeholder="Enter bank reference"
                />,
              )}
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item label="Bank Name">
              {getFieldDecorator('bank_name', {
                rules: [
                  {
                    required: true,
                    message: 'Bank name is required',
                  },
                ],
              })(
                <Select
                  options={banks.map(bank => ({
                    value: bank.bank_description,
                    label: bank.bank_description,
                  }))}
                  showSearch
                  placeholder="Select bank here..."
                />,
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

RemittanceUpdateModal.propTypes = {
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doUpdateRemittanceRequest: PropTypes.func.isRequired,
  doGetBanks: PropTypes.func.isRequired,
  editModalVisibility: PropTypes.bool.isRequired,
  setEditModalVisibility: PropTypes.func.isRequired,
  rowDetails: PropTypes.oneOfType([PropTypes.object]),
  setRowDetails: PropTypes.func,
  onTableUpdate: PropTypes.func,
};

RemittanceUpdateModal.defaultProps = {
  rowDetails: {},
  setRowDetails: null,
  onTableUpdate: null,
};

const mapDispatchToProps = {
  doUpdateRemittanceRequest: editRemittance,
  doGetBanks: getBanks,
};

const WrappedRemittanceUpdateModal = Form.create({
  name: 'RemittanceUpdateModal',
})(RemittanceUpdateModal);

export default connect(
  null,
  mapDispatchToProps,
)(WrappedRemittanceUpdateModal);